import { render, staticRenderFns } from "./StaticalData.vue?vue&type=template&id=59617723&"
import script from "./StaticalData.vue?vue&type=script&lang=js&"
export * from "./StaticalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports